import { useLayoutEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header/Header";
import { fetchAitsTestListRequest } from "../../../redux/aits/aitsSlice";
import { getFormatForApi } from "../../../custom_utilities/pyqFormatUtils";
import PaperListing from "../components/Header/PaperListing/PaperListing";
import PyqListing from "../components/Header/PaperListing/PyqListing";

function AitsPage() {
  const dispatch = useDispatch();

  const { plannerDetails, testDetails, paperName, selectedType } = useSelector(
    (s) => s.examSlice
  );
  const plannerId = plannerDetails?.planner_id;
  const plannerTypeId = plannerDetails?.planner_type_id;
  const paperType = plannerDetails?.id;
  const categoryId = plannerDetails?.category_id;

  const pyqFormatForApi = getFormatForApi({
    format: testDetails?.format,
    paperName,
    selectedType,
  });

  useLayoutEffect(() => {
    dispatch(
      fetchAitsTestListRequest({
        paperType: paperType,
        plannerId,
        plannerTestType: plannerTypeId,
        year: testDetails?.year || 2025,
        ...(pyqFormatForApi ? { format: pyqFormatForApi } : {}),
        categoryId: categoryId || "",
      })
    );
  }, [
    dispatch,
    plannerId,
    plannerTypeId,
    paperType,
    categoryId,
    testDetails?.year,
    pyqFormatForApi,
  ]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "stretch",
      }}
    >
      <Header />
      {plannerDetails?.id === 1 ? <PyqListing /> : <PaperListing />}
    </div>
  );
}

export default AitsPage;
